var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VueApexCharts,{ref:"chart",attrs:{"type":"line","height":"400","options":_setup.chartOptions,"series":_setup.internalSeries}})
}
var staticRenderFns = []

export { render, staticRenderFns }